import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationReportVariationArgs, BackendVariation } from 'src/types/backend';

const MUTATION = gql`
  mutation ReportVariation($id: ID!, $reason: String!, $comment: String) {
    reportVariation(id: $id, reason: $reason, comment: $comment) {
      id
      refundedCount
    }
  }
`;

type Variables = BackendMutationReportVariationArgs;
type Result = Pick<BackendVariation, 'id' | 'refundedCount'>;

export const reportVariation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
